import { UserService } from "@/services";
import localforage, { defineDriver } from "localforage";
import { LocalForageKey } from "@/boot/localforage/initLocalforage";

const userService = new UserService();
const LOGOUT_URL = config.app.url + "/api/oauth/token/revoke";

export const initAuthStore = vueAuth => ({
  state: {
    isAuthenticated: false,
    defaultRoute: '/welcome',
    hasFrontendAccess: false,
    hasApiRole: false,
  },
  mutations: {
    isAuthenticated(state, payload) {
      state.isAuthenticated = payload.isAuthenticated;
    },
    setJwt(state, { access_token, expires_in, refresh_token, token_type }) {
      const now = new Date();

      state.jwt = {
        access_token: access_token,
        expires_in: expires_in * 1000,
        expires_on: new Date(now.getTime() + expires_in * 1000).getTime(),
        refresh_token: refresh_token,
        token_type: token_type
      };
    },
    clearJwt(state) {
      state.jwt = null;
    },
    setDefaultRoute(state, route){
      state.defaultRoute = route;
    },
  },
  actions: {
    login(context, payload) {
      const data = {
        ...payload.user
        // client_id: config.client_id,
        // client_secret: config.client_secret,
        // grant_type: "password"
      };

      return vueAuth.login(data, payload.requestOptions).then(({ data }) => {
        context.commit("setJwt", data);

        context.commit("isAuthenticated", {
          isAuthenticated: vueAuth.isAuthenticated()
        });
      });
    },
    forgotPassword(context, payload) {
      return userService.forgotPassword(payload);
    },
    resetPassword(contect, payload) {
      return userService.resetPassword(payload);
    },
    logoutOffline(context) {
      context.commit("isAuthenticated", {
        isAuthenticated: false
      });

      return context.dispatch("logout", { url: null });
    },
    logout(context, payload = null) {
      if (!payload) payload = { url: LOGOUT_URL };

      const cleanup = () => {
        context.commit("clearJwt", null);
        context.commit("setUser", null);
        context.commit("setContractTemplate", null);

        localforage.removeItem(LocalForageKey.INITIAL_SEARCH_DEPOTS);
        localforage.removeItem(LocalForageKey.INITIAL_SEARCH_TIMESTAMPS);

        context.commit("setDefaultRoute", '/welcome');

        return context.commit("isAuthenticated", {
          isAuthenticated: false
        });
      };

      // vue-authenticate rejects with this error when the session is already gone
      // (expired token / failed refresh). That is an expected 401/400 follow-up,
      // not an application error for Sentry.
      if (!vueAuth.isAuthenticated()) {
        return Promise.resolve(cleanup());
      }

      return vueAuth.logout(payload).then(cleanup).catch(error => {
        if (error && error.message === "There is no currently authenticated user") {
          return cleanup();
        }
        throw error;
      });
    },
    fetchUser(context) {
      return userService.fetchUser().then(user => {

        context.commit('setDefaultRoute', user.has_frontend_access ? '/' : '/account');

        context.dispatch(
          "setAppearance",
          user.preference.appearance.toLowerCase()
        );

        context.dispatch("setUser", user);
        context.dispatch('setContractTemplate', user.client.contract_templates.find((ct) => ct.id == user.preference?.contract_template_id));

        return user;
      });
    },
    refreshAccessToken(context) {
      return vueAuth
        .login({
          refresh_token: context.getters.refreshToken,
        })
        .then(({ data }) => {
          context.commit("setJwt", data);

          context.commit("isAuthenticated", {
            isAuthenticated: vueAuth.isAuthenticated()
          });
        });
    }
  },
  getters: {
    accessToken(state) {
      return state?.jwt?.access_token;
    },
    refreshToken(state) {
      return state?.jwt?.refresh_token;
    },
    accessTokenExpirationDate(state) {
      return state?.jwt?.expires_on ? new Date(state.jwt.expires_on) : null;
    },
    shouldRefreshToken(state, store) {
      const now = new Date();
      const tolerance = 14 * 24 * 60 * 60 * 1000; // 14 days

      if (!store.accessToken || !store.accessTokenExpirationDate) return false;

      return (
        store.accessTokenExpirationDate.getTime() < now.getTime() + tolerance
      );
    },
    isAuthenticated(state) {
      return state.isAuthenticated;
    },
    defaultRoute(state) {
      return state.defaultRoute;
    },
  }
});
